import React, { useEffect } from 'react';
import { loadNamespaces, setDefaultNamespace } from 'i18next';
import '@shared/i18n';
import useUserStore from '@core/stores/useUserStore';
import { getTenantInfo } from '@shared/getTenantInfo';

/**
 * A component that provides internationalization (i18n) support for the application.
 * This component loads the namespaces and sets the default namespace for the application.
 * It is used to wrap the application components and ensure that the i18n namespaces are loaded before rendering.
 *
 * @param {object} props - The component props
 * @param {ReactNode} props.children - The child components to render after authentication
 * @returns The login page or the wrapped children components based on authentication state.
 */

const I18nProvider: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const tenantConfig = useUserStore((state) => state.tenantConfig); // Access tenant configuration from the store

    const { uiKey } = getTenantInfo();

    useEffect(() => {
        // Load namespaces and set default namespace
        const loadI18n = async () => {
            try {
                /*  const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    await response.json();*/
                await loadNamespaces([uiKey]);
                setDefaultNamespace(uiKey); // Set the default namespace
            } catch (error) {
                console.error('Error loading namespaces:', error);
            }
        };

        loadI18n().then((r) => r);
    }, [tenantConfig, uiKey]);

    return <>{children}</>;
};

export default I18nProvider;
